import { useState, useRef, useEffect } from 'react';
import { Input } from './ui/input';

// Sort names alphabetically after PT/CV prefix
const sortByNameAfterPrefix = (a, b) => {
  const stripPrefix = (name) => {
    if (!name) return '';
    const upper = name.toUpperCase().trim();
    // Remove common prefixes for sort comparison
    const prefixes = ['PT. ', 'PT ', 'CV. ', 'CV ', 'UD. ', 'UD ', 'TB. ', 'TB '];
    for (const prefix of prefixes) {
      if (upper.startsWith(prefix)) {
        return upper.substring(prefix.length);
      }
    }
    return upper;
  };
  return stripPrefix(a).localeCompare(stripPrefix(b));
};

export function SearchableSelect({ options, value, onChange, displayKey, valueKey, placeholder, testId }) {
  const [search, setSearch] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  // Find the selected option to display its label
  const selectedOption = options.find(opt => opt[valueKey] === value);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Sort options alphabetically after prefix
  const sortedOptions = [...options].sort((a, b) => sortByNameAfterPrefix(a[displayKey], b[displayKey]));

  const filteredOptions = sortedOptions.filter(opt => {
    if (!search) return true;
    return (opt[displayKey] || '').toUpperCase().includes(search.toUpperCase());
  });

  const handleSelect = (opt) => {
    onChange(opt[valueKey]);
    setSearch('');
    setIsOpen(false);
  };

  return (
    <div ref={wrapperRef} className="relative" data-testid={testId}>
      <Input
        value={isOpen ? search : (selectedOption ? selectedOption[displayKey] : '')}
        onChange={(e) => {
          setSearch(e.target.value);
          if (!isOpen) setIsOpen(true);
        }}
        onFocus={() => {
          setIsOpen(true);
          setSearch('');
        }}
        placeholder={placeholder || 'Ketik untuk mencari...'}
        className="w-full"
        autoComplete="off"
      />
      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((opt) => (
              <div
                key={opt[valueKey]}
                className={`px-3 py-2 text-sm cursor-pointer hover:bg-amber-50 transition-colors ${
                  opt[valueKey] === value ? 'bg-amber-100 font-semibold' : ''
                }`}
                onClick={() => handleSelect(opt)}
              >
                {opt[displayKey]}
              </div>
            ))
          ) : (
            <div className="px-3 py-2 text-sm text-slate-400">Tidak ditemukan</div>
          )}
        </div>
      )}
    </div>
  );
}


